import "./styles/App.scss";
import Layout from "./layout/Layout";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./containers/dashboard";
import Login from "./components/Login";
import Welcome from "./components/controls/Welcome";
import Record from "./containers/records";
import AuthConfig from "./components/Login/authConfiguration";
import Unauthorized from "./components/Login/unauthorized";
import ProtectedRoute from "./components/Login/protectedRoute";
import AuditLogs from "./components/AuditLogs/AuditLogs";
import ProtectedRouteAuditLog from "./components/Login/protectedRouteAuditLog";

const App = () => {
  const isLocalDevelopment = process.env.REACT_APP_LOCAL_DEVELOPMENT === 'true';

  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={isLocalDevelopment ? <Navigate to="/welcome" replace /> : <Login />} />
          <Route path="/auth" element={<AuthConfig />} />
          <Route
            path="/welcome"
            element={
              <ProtectedRoute>
                <Welcome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/record"
            element={
              <ProtectedRoute>
                <Record />
              </ProtectedRoute>
            }
          />
           <Route
            path="/auditLogs"
            element={
              <ProtectedRouteAuditLog>
                <AuditLogs />
              </ProtectedRouteAuditLog>
            }
          />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <Welcome />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </>
  );
};

export default App;
